<template>
    <div class="pa-5" v-if="activeTag">
        <v-data-table
            :headers="tableHeaders"
            :items="activeTag.clients || []"
            :items-per-page="25"
            :footer-props="footerProps"
            dense
            class="clients-table"
        >
            <template v-slot:item="{ item }">
                <tr @click="goToClient(item.id)" style="cursor: pointer;">
                    <td>{{ item.name || "-" }}</td>
                    <td>{{ item.chain_name || "-" }}</td>
                    <td>{{ item.shop_name || "-" }}</td>
                </tr>
            </template>
            <template v-slot:no-data>
                <div class="text-center pa-4">{{ "No clients assigned" | t }}</div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "clients-tab",
    data() {
        return {
            footerProps: { "items-per-page-options": [10, 25, 50] },
            tableHeaders: [
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Chain name"),
                    align: "left",
                    value: "chain_name"
                },
                {
                    text: this.t("Shop name"),
                    align: "left",
                    value: "shop_name"
                }
            ]
        };
    },
    computed: {
        ...mapState("TagStore", ["activeTag"])
    },
    methods: {
        goToClient(clientId) {
            this.$router.push({ name: "client-view", params: { clientId: clientId } });
        }
    }
};
</script>

<style scoped>
.clients-table tr:hover {
    background-color: #f5f5f5;
}
</style>
